var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInteriordesignIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 22.5V13.75C0 13.0625 0.244792 12.474 0.734375 11.9844C1.22396 11.4948 1.8125 11.25 2.5 11.25H3.75V8.75H2.5C1.8125 8.75 1.22396 8.50521 0.734375 8.01562C0.244792 7.52604 0 6.9375 0 6.25V2.5C0 1.8125 0.244792 1.22396 0.734375 0.734375C1.22396 0.244792 1.8125 0 2.5 0H15C15.6875 0 16.276 0.244792 16.7656 0.734375C17.2552 1.22396 17.5 1.8125 17.5 2.5V6.25C17.5 6.9375 17.2552 7.52604 16.7656 8.01562C16.276 8.50521 15.6875 8.75 15 8.75H13.75V11.25H15C15.6875 11.25 16.276 11.4948 16.7656 11.9844C17.2552 12.474 17.5 13.0625 17.5 13.75V22.5H15V18.75H2.5V22.5H0ZM2.5 6.25H15V2.5H2.5V6.25ZM6.25 11.25H11.25V8.75H6.25V11.25ZM2.5 16.25H15V13.75H2.5V16.25ZM2.5 6.25V2.5V6.25ZM2.5 16.25V13.75V16.25Z",
    fill: "#B02F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteriordesignIcon);
export default __webpack_public_path__ + "static/media/interiordesignIcon.32c79395a484fc9e018f00d7d091a419.svg";
export { ForwardRef as ReactComponent };